var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-eff02960": "",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-v-eff02960": "",
    d: "M5 1V5.49999C5 6.60457 5.89897 7.5 7.00141 7.5H15.4986C16.6039 7.5 17.5 6.60277 17.5 5.49999V1H17.8802L23 5.55093V20.9984C23 22.1038 22.1035 23 20.9991 23H3.00091C1.89584 23 1 22.1035 1 20.9991V3.00091C1 1.89584 1.89563 1 3.00267 1H5ZM7 1H15.5V5.00221C15.5 5.27713 15.2726 5.5 15 5.5H7.49998C7.22385 5.5 7 5.27758 7 5.00221V1ZM12 19.5C14.4853 19.5 16.5 17.4853 16.5 15C16.5 12.5147 14.4853 10.5 12 10.5C9.51472 10.5 7.5 12.5147 7.5 15C7.5 17.4853 9.51472 19.5 12 19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.dc5d9ed96ecbd067c03ea2bdf63d05af.svg";
export { ForwardRef as ReactComponent };